<template>
  <div class="shadow">
    <table class="whitespace-nowrap">
      <thead>
        <tr>
          <th class="pl-0">Année {{ year }}</th>
          <th>Tendance</th>
          <th v-for="n in 12" :key="n">{{ SHORT_MONTHS[n - 1].substring(0, 4).toUpperCase() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(label, prop) in tableMapping" :key="prop + year">
          <th class="pr-4">{{ label }}</th>
          <td class="pr-4">
            <apexchart
              width="130"
              height="75"
              type="line"
              :options="{
                chart: {
                  id: 'chart-count_quotes',
                  toolbar: { show: false },
                  zoom: { enabled: false },
                },
                grid: { show: false },
                legend: { show: false },
                tooltip: { enabled: false },
                dataLabels: { enabled: false },
                xaxis: {
                  show: false,
                  labels: { show: false },
                  axisBorder: { show: false },
                  axisTicks: { show: false },
                  crosshairs: { show: false },
                },
                stroke: {
                  show: true,
                  curve: 'smooth',
                  lineCap: 'butt',
                  colors: undefined,
                  width: 2,
                  dashArray: 0,
                },
                yaxis: {
                  show: false,
                  labels: { show: false },
                  axisBorder: { show: false },
                  axisTicks: { show: false },
                  crosshairs: { show: false },
                },
              }"
              :series="[
                {
                  name: 'series-1',
                  data: getSpecificStatAllMonths(prop, year),
                },
              ]"
            />
          </td>
          <td v-for="month in 12" :key="month">
            <span v-if="prop.includes('price')">&euro;&nbsp;</span>{{ getSpecificStat(prop, year, month) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const SHORT_MONTHS = ['JAN', 'FEV', 'MARS', 'AVR', 'MAI', 'JUIN', 'JUIL', 'AOUT', 'SEP', 'OCT', 'NOV', 'DEC']

const props = defineProps({
  stats: { type: Object, required: true },
  year: { type: [Number, String], required: true },
})

const tableMapping = {
  count_quotes: 'Devis',
  sum_price_excl_quotes: 'Devis HTVA',
  count_invoices: 'Factures',
  sum_price_excl_invoices: 'Factures HTVA',
}

const getSpecificStatAllMonths = (prop, year) => {
  const result = []
  for (var i = 1; i <= 12; i += 1) {
    result.push(getSpecificStat(prop, year, i))
  }
  return result
}

const getSpecificStat = (prop, year, month) => {
  let obj = props.stats
  obj = obj.months || {}
  obj = obj[year] || {}
  obj = obj[month] || {}
  if (prop.includes('price')) {
    return (Math.round((obj[prop] || 0) * 100) / 100).toFixed(2)
  }
  return obj[prop] || 0
}
</script>

<style lang="scss" scoped>
table {
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
}

table thead tr:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  th:first-child {
    border-top-left-radius: 8px;
  }
  th:last-child {
    border-top-right-radius: 8px;
  }
}

table tbody tr:last-child {
  th:first-child {
    border-bottom-left-radius: 8px;
  }
  td:last-child {
    border-bottom-right-radius: 8px;
  }
}

table thead th {
  text-align: center !important;
  padding: 8px;
}

table tbody tr td {
  color: black;
  text-align: center !important;
  padding: 8px;
  border: 1px solid black;
  border-left: none;
}

tbody tr td:last-child,
thead tr th:last-child {
  padding-right: 20px;
  padding-left: 10px;
}

tbody tr th {
  padding-left: 20px;
  padding-right: 20px;
  text-align: left !important;
}

table tr:nth-child(even) {
  background-color: #f3f3f3;
}

table tr:nth-child(odd) {
  background-color: #ffffff;
}

table th {
  text-align: left;
  background-color: #000;
  color: white;
  padding: (12px * 1.5) 0;
}
</style>
